import { safeLocalStorage } from '@toss/storage';

import { Logger, LoggerRole, logInTable } from '../../logger';

import type { ExternalEventTrackingClient } from './types';

const CONSOLE_DEBUG_KEY = 'ZETTA_DEBUG';
type ZettaLoggerOptions = {
  role?: LoggerRole;
};

export class ZettaLogger implements Logger {
  public name = 'ZettaLogger';
  public role: LoggerRole;
  private _zettaClient: ExternalEventTrackingClient;

  constructor(
    zettaClient: ExternalEventTrackingClient,
    options?: ZettaLoggerOptions,
  ) {
    this._zettaClient = zettaClient;
    this.role = options?.role ?? 'tracking';
  }

  private _debug(message: string, params: Record<string, unknown> = {}) {
    logInTable(message, {
      name: this.name,
      optionalParams: params,
    });
  }

  log: Logger['log'] = (message, params) => {
    if (safeLocalStorage.get(CONSOLE_DEBUG_KEY) === 'true') {
      this._debug(message, params);
    }

    this._zettaClient.track(message, params);
  };

  debug: Logger['debug'] = (message, params) => {
    this.log(message, params);
  };

  identify(userId: string): void {
    this._zettaClient.identify(userId);
  }

  setUserProperties(userProperties: Record<string, unknown>): void {
    this._zettaClient.setUserProperties(userProperties);
  }
}
